import { setToken, clearToken } from "../../shared/auth";
import { WebLoginDTO } from "../../models/dto/webLoginDto";
import { loginService } from "../../services";
import { utility } from "../../shared/utility";

declare const toastr: any; //toastr è globale (caricato in _Foot.cshtml nelle viste del layout)

$(function () {
    const $form = $("form.form-signin");
    if ($form.length === 0) return;

    $form.on("submit", async function (e) {
        e.preventDefault();

        const dto: WebLoginDTO = {
            email: (($("#Value_Email").val() as string) ?? "").trim(),
            password: (($("#Value_Password").val() as string) ?? "").trim(),
        };

        try {
            //se ho già il token lo elimino
            clearToken();
            const user = await loginService.doLogin(dto);
            setToken(user.token);

            //firmo il token sul server cosi imposta i cookie di sessione
            await loginService.signIn(user);
            toastr?.success?.("Login effettuato con successo");

            //aspetto un attimo prima di fare il redirect
            await utility.delay(1500);

            window.location.href = "/dashboard/index";

        } catch (err: any) {
            const msg = err?.message ?? "Credenziali non valide";
            toastr?.error?.(msg);
        }
    });
});